import rill from "rill";
import set from "@rill/set";

import controller from "./scheduling.controller";

const Scheduling = (app) => {
  app.at(
    "/scheduling/*",
    rill()
      .use(set("heading", ["Coaching", "Scheduling"]))
      .setup((app) => {
        app.get("/", controller);
      })
  );
};

export default Scheduling;